import routes from '@/services/api/api'
import axios from 'axios'

/**
 * @description
 * Login  user request
 * 
 * @param {oject} params
 * @return {Promise} user data, null in otherwise
 */
const loginRequest = async function(params) {
    return new Promise((resolve, reject) => {
        axios({
            url: routes.LOGIN_REQUEST,
            data: {
                rut: params.rut,
                password: params.password,
                remember_me: params.remember_me,
            },
            method: 'POST',
        })
            .then(response => {
                resolve(response)
            })
            .catch(err => {
                reject(err)
            })
    }) // end promise
} // end function

/**
 * @description
 * Send request for logout tp logged user
 * 
 * @param {oject} params
 * @return {Promise} success or error response
 */
const logoutRequest = async function() {
    return new Promise((resolve, reject) => {
        axios({ 
            url: routes.LOGOUT_REQUEST,
            data: {},
            method: 'GET'
        })
            .then(response => {
                resolve(response)
            })
            .catch(err => {
                reject(err)
            })
    })
} // end function

/**
 * @description
 * Send request for send restore pass link to email
 * 
 * @param {oject} params
 * @return {Promise} success or error response
 */
const sendEmailPasswordRequest = async function(params) {
    return new Promise((resolve, reject) => {
        axios({
            url: routes.PASSWORD_EMAIL_REQUEST, 
            data: {
                email: params.email,
            },
            method: 'POST',
        })
            .then(response => {
                resolve(response)
            })
            .catch(err => {
                reject(err)
            })
    })
} // end function

/**
 * @description
 * Send request for reset user password
 * 
 * @param {oject} params
 * @return {Promise} success or error response
 */
const resetPasswordRequest = async function(params) {
    return new Promise((resolve, reject) => {
        axios({
            url: routes.PASSWORD_RESET_REQUEST,
            data: {
                rut: params.rut,
                password: params.password,
                password_repeat: params.password_repeat,
                token: params.token,
            }, 
            method: 'POST',
        })
            .then(response => {
                resolve(response)
            })
            .catch(err => {
                reject(err)
            })
    })
} // end function

/**
 * @description
 * Send request for reset user password
 * 
 * @param {oject} params
 * @return {Promise} success or error response
 */
const generateTemporalModuleTokenRequest = async function(params) {
    return new Promise((resolve, reject) => {
        let userToken = process.env.VUE_APP_BY_PASS_LOGIN === 'false' ? params.user_token : 'test_token'   
        axios({
            url: routes.GENERATE_TEMPORAL_MODULE_TOKEN_REQUEST,
            data: {
                user_token: userToken,
            }, 
            method: 'POST',
        })
            .then(response => {
                resolve(response)
            })
            .catch(err => {
                reject(err)
            })
    })
} // end function

export {
    loginRequest,
    logoutRequest,
    sendEmailPasswordRequest,
    resetPasswordRequest,
    generateTemporalModuleTokenRequest,
}
